// src/private/stickyShapes.js
// Shared sticky-note shape presets — used by InfiniteCanvas.js's "+nota"
// toolbar picker and PostItNode.js's right-click shape switcher.
export const STICKY_SHAPES = {
  rect: { w: 200, h: 140, radius: "12px", label: "Rettangolo" },
  square: { w: 160, h: 160, radius: "14px", label: "Quadrato" },
  circle: { w: 160, h: 160, radius: "50%", label: "Cerchio" },
};
